import { Avatar, IconButton, ListItemIcon, MenuItem } from '@mui/material';
import React from 'react';
import { FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';
import { useSignOut } from '~/api/session_queries';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import { PremiumIcon } from '~/sites/beatsperminute/components/premium/StripePremiumDialogContent';
import { getLcn } from '~/utils/labeled-classnames';
import BannerMenu, { useBannerMenu } from './BannerMenu';
import { BiEnvelope } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { useIsAtOrNarrowerThan, useIsAtOrWiderThan } from '../utils/useBreakpoint';

export function UserMenu({
  children,
  hasPass
}: {
  children?: React.ReactNode,
  hasPass?: boolean
}) {
  const { setShowSignInDialog, sessionUser } = useCommonAppContext();
  const navigate = useNavigate();
  const isXs = useIsAtOrNarrowerThan('xs');

  const signOut = useSignOut();
  const { anchorEl, isOpen, handleClick, handleClose } = useBannerMenu()
  const avatarSize = isXs ? 30 : 40;

  const lcn = getLcn({
    userMenu: ''
  });

  const alt = sessionUser ? `${sessionUser.first_name} ${sessionUser.last_name}` : 'User Menu'
  const src = sessionUser ? sessionUser.image_url : undefined
  const bgcolor = sessionUser ? 'primary.main' : undefined

  return (
    <div className={lcn.userMenu}>

      <IconButton onClick={handleClick}>
        <Avatar
          alt={alt}
          src={src}
          sx={{ width: avatarSize, height: avatarSize, bgcolor }}
        />
        {hasPass && <PremiumIcon color='white' className='text-[80%] absolute right-0 bottom-[.05rem]' />}
      </IconButton>

      <BannerMenu
        anchorEl={anchorEl}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        {sessionUser ?
          [
            <div key={'email'} className='p-3'>
              <div>{sessionUser.email}</div>
            </div>,

            children,

            <MenuItem key={'sign-out'} onClick={signOut}>
              <ListItemIcon>
                <Avatar>
                  <FaSignOutAlt />
                </Avatar>
              </ListItemIcon>
              Sign Out
            </MenuItem>
          ]
          :
          <>
            <MenuItem onClick={() => setShowSignInDialog(true)}>
              <ListItemIcon>
                <Avatar>
                  <FaSignInAlt />
                </Avatar>
              </ListItemIcon>
              Sign In!
            </MenuItem>
            <MenuItem component='a' onClick={() => navigate('/home/contact')}>
              <ListItemIcon>
                <Avatar>
                  <BiEnvelope />
                </Avatar>
              </ListItemIcon>
              Contact
            </MenuItem>
          </>
        }
      </BannerMenu>
    </div >
  );
}; 